import { Component, inject, input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { first } from 'rxjs';
import { EmemberComponent } from '../modules/emember/emember.component';
import { TesterGateService } from '../modules/emember/components/tester-gate/tester-gate.service';

@Component({
  selector: 'ava-emember-element',
  template: ` <ava-emember [embedded]="embedded()" /> `,
  standalone: true,
  imports: [CommonModule, EmemberComponent],
})
export class AvaEmemberCustomElementComponent implements OnInit {
  private router = inject(Router);
  private testerGate = inject(TesterGateService);
  private testerGateOpen$ = toObservable(this.testerGate.open);

  embedded = input(false);

  ngOnInit() {
    if (this.testerGate.open()) {
      this.router.initialNavigation();
      return;
    }

    // behind the tester gate nothing routes, so no guard loads prices or the member until the code is in
    this.testerGateOpen$.pipe(first(Boolean)).subscribe(() => this.router.initialNavigation());
  }
}
